export const constants = {
    'apiUrl': 'https://backend.davkabeauty.com.au',
    // 'apiUrl': 'http://localhost:3001'
    };
    